import React from 'react';
import Header from './components/Header';
import AcronymSearch from './components/AcronymSearch';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <AcronymSearch />
      <Footer />
    </div>
  );
}

export default App;

